// Footer.js
import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <span>Copyright © 2025 IGEL</span>
      <span className="version"> Version {process.env.REACT_APP_VERSION}</span>
    </footer>
  );
}

export default Footer;
